import * as _ from 'lodash';
// import moment from 'moment';
// import * as str from 'underscore.string';
export const TranformtionPoliciesServerToClientFilterObject = {
    "name": "policiesServerToClient",
    "filter": [() => {
        return (inputJson, _categoriesWithRule, metaData) => {
            let outputJson = {};
            outputJson.policies = [];
            outputJson.MetaData = {
                envTypes: _.map(metaData.enviromentTypes, (env) => {
                    delete env.$$hashKey;
                    return env;
                }),
                actions: metaData.actions,
                dbTypes: metaData.dbTypes,
                categoriesWithRule: []
            };
            return [outputJson];
        };
    }]
};



// WEBPACK FOOTER //
// ./src/app/authorized/policyEngine/transofromtions/trans.policiesServerToClient.js